import moment from 'moment-timezone'
import Convertdec from 'decimal-number-to-words'
import { parseDateTime } from '/utils/date-time'

const FieldFormatter = (field) => {

  if (field.type === "money") {
    const numericValue=parseFloat(field.value)
    return numericValue.toLocaleString('en-US', { style: 'currency', currency: field.currencyCode })
  }
  
  if (field.type === "number") {
      const numericValue = parseFloat(field.value)

      switch (field.numberStyle) {
        case "PKNumberStyleDecimal": return numericValue
        case "PKNumberStylePercent": return numericValue * 100 + "%"
        case "PKNumberStyleScientific": return numericValue.toExponential().replace("e+0", "E0")
        case "PKNumberStyleSpellOut": return Convertdec.toWords(numericValue)
      }
  }

  if (field.dateStyle || field.timeStyle) {

    const dateTimeMoment = parseDateTime(field.value, field.ignoresTimeZone)

    if (!dateTimeMoment.isValid()) return "-"

    let formattedValue = ""

    if (field.dateStyle) {

      if (field.isRelative) {
        if (moment().subtract(1, "days").format("YYYY-MM-DD") === dateTimeMoment.format("YYYY-MM-DD")) return "Yesterday"
        if (moment().format("YYYY-MM-DD") === dateTimeMoment.format("YYYY-MM-DD")) return "Today"
        if (moment().add(1, "days").format("YYYY-MM-DD") === dateTimeMoment.format("YYYY-MM-DD")) return "Tomorrow"
      }

      switch (field.dateStyle) {
        case "PKDateStyleNone": break
        case "PKDateStyleShort": formattedValue = dateTimeMoment.format("DD/MM/YY"); break
        case "PKDateStyleMedium": formattedValue = dateTimeMoment.format("DD MMM YYYY"); break
        case "PKDateStyleLong": formattedValue = dateTimeMoment.format("DD MMMM YYYY"); break
        case "PKDateStyleFull": formattedValue = dateTimeMoment.format("dddd DD MMMM YYYY"); break
      }
    }

    if (field.dateStyle && field.dateStyle !== "PKDateStyleNone" && field.timeStyle && field.timeStyle !== "PKDateStyleNone") {
      formattedValue += ", "
    }

    // TODO - Can I improve on timezone handling?

    if (field.timeStyle) {
      switch (field.timeStyle) {
        case "PKDateStyleNone": break
        case "PKDateStyleShort": formattedValue += dateTimeMoment.format("HH:mm"); break
        case "PKDateStyleMedium": formattedValue += dateTimeMoment.format("HH:mm:ss"); break
        case "PKDateStyleLong": formattedValue += dateTimeMoment.format("HH:mm:ss") + " GMT"; break // GMT
        case "PKDateStyleFull": formattedValue += dateTimeMoment.format("HH:mm:ss") + " Greenwich Mean Time"; break // Greenwich Mean Time
      }
    }

    return formattedValue
  }

  return field.value
}

export default FieldFormatter
